<template>
  <custom-dialog width="850px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body ub app-version-bd">
      <div class="ub-f2" style="padding-right: 40px">
        <ul>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.ying_yong_ming_cheng') }}</span>
            <span class="value">{{ info.appName }}</span>
          </li>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.shi_yong_zhong_duan') }}</span>
            <span class="value">{{ getDicValue('app_version_os', info.versionOs) }}</span>
          </li>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.ban_ben_hao') }}</span>
            <span class="value">{{ info.versionCode }}</span>
          </li>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.sheng_ji_fang_shi') }}</span>
            <span class="value">{{ getDicValue('app_upgrade_mode', info.upgradeMode) }}</span>
          </li>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.sfmrbb') }}</span>
            <span class="value">{{ getDicValue('isynergy_cloud_bool', info.isDefault) }}</span>
          </li>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.zhuang_tai') }}</span>
            <span class="value">{{ getDicValue('cloud_valid_invalid_state', info.state) }}</span>
          </li>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.zi_yuan_lu_jing') }}</span>
            <span class="value">{{ info.fullPath }}</span>
          </li>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.zi_yuan_da_xiao') }}</span>
            <span class="value">{{ (info.resSize / 1024 / 1024) | formatNumberCalc(2) }} M</span>
          </li>
          <li>
            <span class="label">{{ $t('base_ercode_dialog.ban_ben_miao_shu') }}</span>
            <span class="value">{{ info.versionDesc }}</span>
          </li>
        </ul>
      </div>
      <div class="ub-f1">
        <qrcode-vue :value="info.fullPath" :size="230"></qrcode-vue>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="visible = false">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: { QrcodeVue },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.info = this.model.row;
    },
  },
};
</script>

<style lang="scss">
.app-version-bd {
  ul > li {
    padding-left: 12px;
    font-size: 12px;
    line-height: 26px;
    .label {
      font-weight: bold;
    }
  }
}
</style>
